// components/common/RichText.tsx
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface RichTextProps {
    html?: string;
    sx?: SxProps<Theme>;
}

export default function RichText({ html, sx }: RichTextProps) {
    if (!html) return null;
    return (
        <Box
            sx={{
                // 段落
                '& p': {
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '1.3rem',
                    letterSpacing: 0,
                    margin: 0,
                    paddingTop: '1rem',
                    paddingBottom: '0.5rem',
                },
                // 清單
                '& ul': {
                    paddingLeft: '1.25rem',
                    listStyleType: 'disc',
                    listStylePosition: 'outside',
                    margin: 0,
                    paddingTop: '0.5rem',
                    paddingBottom: '0.5rem',
                },
                '& li': {
                    fontFamily: 'Poppins',
                    fontWeight: 400,
                    fontSize: '16px',
                    lineHeight: '1.3rem',
                    letterSpacing: 0,
                    marginBottom: '6px',
                    '&::marker': { color: '#B75332' }, // 你原本的點點顏色
                },
                ...sx,
            }}
            // 這裡吃的是 CMS 產的 HTML
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}
